import { useState, useEffect } from 'react';
import { getDocByQuery, getDocsByQuery } from 'repositories/firebase';
import { COLLECTIONS } from 'constant';
import { IUser } from 'types';

export const usePendingUsers = () => {
  const [pendingUsers, setPendingUsers] = useState<IUser[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPendingUsers = async () => {
    try {
      setLoading(true);
      const q = await getDocsByQuery<IUser>(
        COLLECTIONS.USER,
        'accountStatus',
        'pending'
      );
      if (q) {
        setPendingUsers(q);
      } else {
        setPendingUsers([]);
      }
    } catch (err) {
      console.error('Error fetching users with pending status:', err);
      setError('Failed to fetch pending users');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPendingUsers();
  }, []);

  return { pendingUsers, loading, error, fetchPendingUsers };
};
